// extracted by mini-css-extract-plugin
export default {"description":"style_description__-FmBa","fade-in":"style_fade-in__yH5+T","top":"style_top__sJKGz","image":"style_image__Bk2mf"};